/* istanbul ignore file */
import { createUseStyles } from '@glu/theming';
import './themeDefaults';

const styles = ({ switchReact }) => ({
  switchWrapper: {
    display: 'inline-block',
    verticalAlign: 'middle',
    cursor: 'pointer',
    position: 'relative'

  },
  switchInput: {
    opacity: 1,
    width: 32,
    height: 16,
    padding: 0,
    margin: 0,
    position: 'absolute',
    top: 0,
    left: 0,
    '&:checked ~ div': {
      background: ({ disabled }) => (disabled
        ? switchReact.disabledBackground
        : switchReact.onBackground),
      '&:after': {
        left: 'auto',
        right: 1,
        top: 1
      }
    }
  },
  switchFill: {
    background: ({ disabled }) => (disabled
      ? switchReact.disabledBackground
      : switchReact.offBackground),
    borderRadius: 8,
    height: 16,
    width: 32,
    position: 'relative',
    '&:after': {
      content: "''",
      borderRadius: 7,
      width: 14,
      height: 14,
      background: 'white',
      position: 'absolute',
      left: 1,
      top: 1
    }
  },
  labelText: {
    cursor: ({ disabled }) => (disabled ? 'default' : 'pointer'),
    marginRight: ({ labelOnLeft }) => (labelOnLeft ? 10 : 0),
    marginLeft: ({ labelOnLeft }) => (labelOnLeft ? 0 : 10),
    display: 'inline-block',
    verticalAlign: 'middle',
    fontSize: 14,
    lineHeight: '16px'
  }
});

export default createUseStyles(styles);
